import { fromJS } from 'immutable';

export default fromJS({
    groupMembership: {},
    groupMembershipToAdd: undefined,
    hasEnrolledOrInvitedMembers: false
});